import SET from './SET'
import HSET from './HSET'
import HSETNX from './HSETNX'
import DEL from './DEL'
import HDEL from './HDEL'
import HINCRBY from './HINCRBY'
import HINCRBYFLOAT from './HINCRBYFLOAT'
import INCR from './INCR'
import INCRBY from './INCRBY'
import INCRBYFLOAT from './INCRBYFLOAT'
import SETNX from './SETNX'
import RPOP from './RPOP'
import RPUSH from './RPUSH'

export default {
  SET,
  SETNX,
  HSET,
  HSETNX,
  DEL,
  HDEL,
  INCR,
  INCRBY,
  INCRBYFLOAT,
  HINCRBY,
  HINCRBYFLOAT,
  RPOP,
  RPUSH,
}
